import { LegalDocument } from "@/app/components/legal/LegalDocument";
import { privacyPolicyContent as c } from "@/app/content/legalContent";

interface PrivacyPolicyProps {
  mode?: "modal" | "page";
  onClose?: () => void;
}

export function PrivacyPolicy({ mode = "page", onClose }: PrivacyPolicyProps) {
  return (
    <LegalDocument title={c.title} closeLabel={c.closeLabel} mode={mode} onClose={onClose}>
      <p className="text-lg text-slate-600 mb-8">
        <strong>Data ostatniej aktualizacji:</strong> {c.lastUpdated}
      </p>

      {c.sections.map((section) => (
        <section key={section.heading} className="mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-4">{section.heading}</h2>

          {section.rawHtml ? (
            // Content authored in legalContent.ts — not user input, safe to render
            <div
              className="text-slate-700 leading-relaxed privacy-content"
              dangerouslySetInnerHTML={{ __html: section.rawHtml }}
            />
          ) : section.subsections ? (
            section.subsections.map((sub) => (
              <div key={sub.heading}>
                <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6">{sub.heading}</h3>
                {sub.paragraphs?.map((p, i) => (
                  <p key={i} className="leading-relaxed mb-4">
                    {p}
                  </p>
                ))}
                {sub.items && (
                  <ul className="list-disc pl-6 mb-4 space-y-2">
                    {sub.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))
          ) : (
            <>
              {section.paragraphs?.map((p, i) => (
                <p key={i} className="leading-relaxed mb-4">
                  {p}
                </p>
              ))}
              {section.items && (
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  {section.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
            </>
          )}
        </section>
      ))}
    </LegalDocument>
  );
}
